<template>
  <v-dialog
    :value="showCertificateAlert"
    persistent
    max-width="600"
    scrollable
    :retain-focus="false"
  >
    <v-card>
      <v-card-title class="pa-4">
        <div class="dialog-title-wrapper">
          <div class="dialog-title-text">
            {{ $t('certificateExpiration.expirationAlertTitle') }}
          </div>

          <v-btn icon class="dialog-title-close" @click="closeDialog">
            <v-icon>mdi-window-close</v-icon>
          </v-btn>
        </div>
      </v-card-title>

      <v-card-text class="certificates-scroll">
        <v-col
          v-for="(
            { name, cif, certificateExpiration }, index
          ) in alertCertificates"
          :key="index"
          align="center"
        >
          <p class="font-weight-medium mb-0">
            {{ `${name} ( ${cif} )` }}
          </p>

          <p :class="getStatusColor(certificateExpiration)" class="mb-0">
            {{ getDialogBody(certificateExpiration) }} ({{
              $d(new Date(certificateExpiration.toDate()), 'i18nDate')
            }})
          </p>

          <!--v-divider v-if="index < certificates.length - 1" class="my-3" /-->
        </v-col>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { today, thirtyDays, ninetyDays } from '@/utils/date-utils'

export default {
  props: {
    certificates: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  data() {
    return {
      closed: false,
    }
  },
  methods: {
    async closeDialog() {
      this.closed = true
    },
    getCertExpirationISO(certificateExpiration) {
      return certificateExpiration.toDate().toISOString().slice(0, 10)
    },
    getCertificateStatus(certificateExpiration) {
      const certExpiration = this.getCertExpirationISO(certificateExpiration)

      if (certExpiration < today()) return 'expired'
      if (certExpiration < thirtyDays()) return '30'
      if (certExpiration < ninetyDays()) return '90'
      return null
    },
    getDialogBody(certificateExpiration) {
      const status = this.getCertificateStatus(certificateExpiration)

      if (status === 'expired')
        return this.$t('certificateExpiration.alreadyExpired')

      if (status === '30')
        return this.$t('certificateExpiration.expirationDialogBodyThirtyDays')

      if (status === '90')
        return this.$t('certificateExpiration.expirationDialogBodyNinetyDays')

      return ''
    },
    getStatusColor(certificateExpiration) {
      const status = this.getCertificateStatus(certificateExpiration)

      switch (status) {
        case 'expired':
          return 'red--text text--darken-2'
        case '30':
          return 'orange--text text--darken-2'
        case '90':
          return 'amber--text text--darken-2'
        default:
          return ''
      }
    },
  },
  computed: {
    // Solo certificados que disparan alerta
    alertCertificates() {
      return this.certificates.filter(
        ({ certificateExpiration }) =>
          this.getCertExpirationISO(certificateExpiration) <= ninetyDays()
      )
    },
    showCertificateAlert() {
      // El dialogo se muestra si al menos uno cumple la condicion
      return !this.closed && this.alertCertificates.length > 0
    },
  },
}
</script>

<style lang="scss" scoped>
.my-checkbox .v-label {
  font-size: 15px;
}

.certificates-scroll {
  max-height: 60vh;
  overflow-y: auto;
}

.dialog-title-wrapper {
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: start;
  column-gap: 8px;
  width: 100%;
}

.dialog-title-text {
  text-align: center;
  font-size: 20px;
  font-weight: 500;
  line-height: 1.3;

  white-space: normal;
  word-break: normal;
  overflow-wrap: break-word;
}

.dialog-title-close {
  margin-top: -4px;
}
</style>
